import { render, staticRenderFns } from "./CallDetailInfo.vue?vue&type=template&id=f03f45d2&"
import script from "./CallDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./CallDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports